const QuestionMarkIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.5 2.08334C6.74998 2.08334 2.08331 6.75001 2.08331 12.5C2.08331 18.25 6.74998 22.9167 12.5 22.9167C18.25 22.9167 22.9166 18.25 22.9166 12.5C22.9166 6.75001 18.25 2.08334 12.5 2.08334ZM13.5416 19.7917H11.4583V17.7083H13.5416V19.7917ZM15.6979 11.7188L14.7604 12.6771C14.0104 13.4375 13.5416 14.0625 13.5416 15.625H11.4583V15.1042C11.4583 13.9583 11.9271 12.9167 12.6771 12.1563L13.9687 10.8438C14.3541 10.4688 14.5833 9.94793 14.5833 9.37501C14.5833 8.22918 13.6458 7.29168 12.5 7.29168C11.3541 7.29168 10.4166 8.22918 10.4166 9.37501H8.33331C8.33331 7.07293 10.1979 5.20834 12.5 5.20834C14.8021 5.20834 16.6666 7.07293 16.6666 9.37501C16.6666 10.2917 16.2916 11.125 15.6979 11.7188Z" />
    </svg>
  );
};

export default QuestionMarkIcon;
